import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var Item = function Item(data, prev, next) {
  _classCallCheck(this, Item);

  this.next = next;

  if (next) {
    next.prev = this;
  }

  this.prev = prev;

  if (prev) {
    prev.next = this;
  }

  this.data = data;
};

export var LinkedList =
/*#__PURE__*/
function () {
  function LinkedList() {
    _classCallCheck(this, LinkedList);

    this._length = 0;
  }

  _createClass(LinkedList, [{
    key: "push",
    value: function push(data) {
      this._tail = new Item(data, this._tail);

      if (this._length === 0) {
        this._head = this._tail;
        this._current = this._head;
        this._next = this._head;
      }

      this._length++;
    }
  }, {
    key: "pop",
    value: function pop() {
      var tail = this._tail;

      if (this._length === 0) {
        return;
      }

      this._length--;

      if (this._length === 0) {
        this._head = this._tail = this._current = this._next = undefined;
        return tail.data;
      }

      this._tail = tail.prev;
      this._tail.next = undefined;

      if (this._current === tail) {
        this._current = this._tail;
        this._next = undefined;
      }

      return tail.data;
    }
  }, {
    key: "shift",
    value: function shift() {
      var head = this._head;

      if (this._length === 0) {
        return;
      }

      this._length--;

      if (this._length === 0) {
        this._head = this._tail = this._current = this._next = undefined;
        return head.data;
      }

      this._head = this._head.next;

      if (this._current === head) {
        this._current = this._head;
        this._next = this._current.next;
      }

      return head.data;
    }
  }, {
    key: "unshift",
    value: function unshift(data) {
      this._head = new Item(data, undefined, this._head);

      if (this._length === 0) {
        this._tail = this._head;
        this._next = this._head;
      }

      this._length++;
    }
  }, {
    key: "unshiftCurrent",
    value: function unshiftCurrent() {
      var current = this._current;

      if (current === this._head || this._length < 2) {
        return current && current.data;
      } // remove


      if (current === this._tail) {
        this._tail = current.prev;
        this._tail.next = undefined;
        this._current = this._tail;
      } else {
        current.next.prev = current.prev;
        current.prev.next = current.next;
        this._current = current.prev;
      }

      this._next = this._current.next; // unshift

      current.next = this._head;
      current.prev = undefined;
      this._head.prev = current;
      this._head = current;
      return current.data;
    }
  }, {
    key: "removeCurrent",
    value: function removeCurrent() {
      var current = this._current;

      if (this._length === 0) {
        return;
      }

      this._length--;

      if (this._length === 0) {
        this._head = this._tail = this._current = this._next = undefined;
        return current.data;
      }

      if (current === this._tail) {
        this._tail = current.prev;
        this._tail.next = undefined;
        this._current = this._tail;
      } else if (current === this._head) {
        this._head = current.next;
        this._head.prev = undefined;
        this._current = this._head;
      } else {
        current.next.prev = current.prev;
        current.prev.next = current.next;
        this._current = current.prev;
      }

      this._next = this._current.next;
      return current.data;
    }
  }, {
    key: "resetCursor",
    value: function resetCursor() {
      this._current = this._next = this._head;
      return this;
    }
  }, {
    key: "next",
    value: function next() {
      var next = this._next;

      if (next !== undefined) {
        this._next = next.next;
        this._current = next;
        return next.data;
      }
    }
  }, {
    key: "head",
    get: function get() {
      return this._head && this._head.data;
    }
  }, {
    key: "tail",
    get: function get() {
      return this._tail && this._tail.data;
    }
  }, {
    key: "current",
    get: function get() {
      return this._current && this._current.data;
    }
  }, {
    key: "length",
    get: function get() {
      return this._length;
    }
  }]);

  return LinkedList;
}();